export default {
    message: {
        calculator: {
            btn1_link: "/en-au/products/citrix-workspace/form/pricing-inquiry/",
        }
    }
}